import React from 'react';
import {
    Document, Page, Text, View, StyleSheet, Image, pdf
} from '@react-pdf/renderer';
import PDFHeader from './PDFHeader';
import PDFFooter from './PDFFooter';

const PRIMARY_COLOR = '#4C52AD';

const styles = StyleSheet.create({
    page: {
        fontSize: 10,
        padding: 0,
        fontFamily: 'Helvetica',
        position: 'relative',
        border: '1pt solid #000',
    },
    content: {
        padding: 20,
        paddingBottom: 80, // Space for footer
        minHeight: '90%', // Ensures footer stays at bottom
    },
    table: {
        marginTop: 10,
        border: '1pt solid black',
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottom: '1pt solid black',
    },
    tableHeader: {
        backgroundColor: PRIMARY_COLOR,
        color: '#fff',
    },
    cell: {
        flex: 1,
        padding: 5,
        textAlign: 'center',
        borderRight: '1pt solid black',
    },
    noRightBorder: {
        borderRight: 0,
    },
    customerInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10,
    },
    totalSection: {
        marginTop: 15,
        textAlign: 'right',
        fontWeight: 'bold',
        fontSize: 12,
    },
});

const BillPdfDocument = ({ bill, currentOrder, hotel_details }) => {
    const userType = localStorage.getItem("billing_app_type");
    const items = bill?.items || [];
    const totalPrice = bill?.total_amount || '0.00';
    const orderItems = currentOrder.items.map((item) => {
        const food = currentOrder.food_items.find(f => f.id === item.food);
        const table = currentOrder.table;
        const room = currentOrder.room;
        const quantity = item.quantity;
        const price = food ? food.price : 0;
        const name = food ? food.name : 'Unknown';
        const subtotal = quantity * price;

        return {
            name,
            quantity,
            price,
            total: subtotal,
            table: table,
            room: room
        };
    });

    // Determine whether to show room or table based on userType
    const showRoom = userType === "Hotel and Restaurant";

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.content}>
                    <PDFHeader data={hotel_details} />

                    <View style={styles.customerInfo}>
                        <View>
                            <Text>Customer Name: {bill.customer_name}</Text>
                            <Text>Email: {bill.customer_email}</Text>
                            <Text>Phone: {bill.customer_phone}</Text>
                            <Text>
                                {`Table: ${currentOrder?.table_info?.name || '-'}`}
                            </Text>
                            {
                                showRoom &&
                                <Text>
                                    {`Room: ${currentOrder?.room_info?.no || '-'}`}
                                </Text>
                            }
                        </View>
                        <View style={{ alignItems: 'flex-end' }}>
                            <Text>Bill ID: {bill.id}</Text>
                            <Text>Date: {new Date(bill.created_at).toLocaleDateString()}</Text>
                        </View>
                    </View>

                    <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeader]}>
                            {['#', 'Item', 'Qty', 'Price', 'Subtotal'].map((title, i, arr) => (
                                <Text key={i} style={[styles.cell, i === arr.length - 1 && styles.noRightBorder]}>
                                    {title}
                                </Text>
                            ))}
                        </View>

                        {orderItems.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <Text style={styles.cell}>{index + 1}</Text>
                                <Text style={styles.cell}>{item.name}</Text>
                                <Text style={styles.cell}>{item.quantity}</Text>
                                <Text style={styles.cell}>Rs.{item.price}</Text>
                                <Text style={[styles.cell, styles.noRightBorder]}>Rs.{item.total}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.totalSection}>
                        <Text>Total: Rs.{totalPrice}</Text>
                    </View>
                </View>

                <PDFFooter
                    hotelName={hotel_details?.hotel_detail?.name}
                    contactEmail={hotel_details?.email}
                    contactPhone={hotel_details?.hotel_detail?.contact}
                />
            </Page>
        </Document>
    );
};

export default BillPdfDocument;



export const downloadPDF = async (billData, currentOrder, hotel_details) => {
    const blob = await pdf(<BillPdfDocument bill={billData} currentOrder={currentOrder} hotel_details={hotel_details} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Bill${billData?.id || 'bill'}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
